import { Todo } from "./types/Todo";

export default function updateTodo(ref, data) {
	return ref.set(Todo.partial().parse(data), { merge: true });
}
